/* ============================================
   🐣 EASTER EGG HUNT – HobbyHorse24
   JavaScript Controller
   ============================================ */

(function() {
  'use strict';

  const STORAGE_KEY = 'hh24-easter-eggs';
  const TOOLTIP_KEY = 'hh24-easter-tooltip-shown';
  const TOTAL_EGGS = 5;
  const DISCOUNT_CODE = 'OSTEREI10';

  /* --- STATE --- */
  function getFoundEggs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function saveFoundEggs(eggs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(eggs));
    } catch(e) {}
  }

  function isTooltipShown() {
    try {
      return localStorage.getItem(TOOLTIP_KEY) === 'true';
    } catch(e) {
      return false;
    }
  }

  function markTooltipShown() {
    try {
      localStorage.setItem(TOOLTIP_KEY, 'true');
    } catch(e) {}
  }

  /* --- EGG CLICK HANDLER --- */
  function onEggClick(eggEl) {
    const eggId = eggEl.dataset.eggId;
    if (!eggId) return;

    const found = getFoundEggs();
    if (found.includes(eggId)) return;

    // Mark as found
    found.push(eggId);
    saveFoundEggs(found);

    // Animate egg disappearing
    eggEl.classList.add('easter-egg--found');

    // Show toast
    showToast(found.length);

    // Update tracker
    updateTracker(found);

    // Check if all found
    if (found.length >= TOTAL_EGGS) {
      setTimeout(function() {
        showConfetti();
        openTrackerPanel();
      }, 600);
    }
  }

  /* --- TOAST --- */
  function showToast(count) {
    // Remove existing toast
    var existing = document.querySelector('.easter-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'easter-toast';

    if (count >= TOTAL_EGGS) {
      toast.textContent = '🎉 Alle ' + TOTAL_EGGS + ' Eier gefunden! Du hast es geschafft!';
    } else {
      toast.textContent = '🥚 Osterei gefunden! (' + count + '/' + TOTAL_EGGS + ')';
    }

    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toast.classList.add('is-visible');
      });
    });

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() { toast.remove(); }, 400);
    }, 3000);
  }

  /* --- TRACKER --- */
  function updateTracker(found) {
    if (!found) found = getFoundEggs();

    // Update badge
    var badge = document.querySelector('.easter-tracker__badge');
    if (badge) badge.textContent = found.length;

    // Update egg slots
    for (var i = 1; i <= TOTAL_EGGS; i++) {
      var slot = document.querySelector('.easter-tracker__egg-slot[data-slot="' + i + '"]');
      if (slot) {
        if (found.includes('egg-' + i)) {
          if (!slot.classList.contains('is-found')) {
            slot.classList.add('is-found');
            slot.innerHTML = '🥚';
          }
        }
      }
    }

    // Update progress text
    var progress = document.querySelector('.easter-tracker__progress');
    if (progress) {
      progress.textContent = found.length + ' von ' + TOTAL_EGGS + ' Ostereiern gefunden';
    }

    // Show reward if all found
    var reward = document.querySelector('.easter-tracker__reward');
    if (reward && found.length >= TOTAL_EGGS) {
      reward.classList.add('is-visible');
    }
  }

  function openTrackerPanel() {
    var panel = document.querySelector('.easter-tracker__panel');
    if (panel) panel.classList.add('is-open');
  }

  /* --- CONFETTI --- */
  function showConfetti() {
    var container = document.createElement('div');
    container.className = 'easter-confetti';
    document.body.appendChild(container);

    var colors = ['#f4a7c1', '#a8e6cf', '#c3b1e1', '#ffeaa7', '#ff9ff3', '#55efc4'];

    for (var i = 0; i < 60; i++) {
      var piece = document.createElement('div');
      piece.className = 'easter-confetti__piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[Math.floor(Math.random() * colors.length)];
      piece.style.width = (Math.random() * 8 + 5) + 'px';
      piece.style.height = (Math.random() * 8 + 5) + 'px';
      piece.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
      piece.style.animationDuration = (Math.random() * 2 + 2) + 's';
      piece.style.animationDelay = (Math.random() * 1.5) + 's';
      container.appendChild(piece);
    }

    setTimeout(function() { container.remove(); }, 5000);
  }

  /* --- TOOLTIP --- */
  function showEasterTooltip() {
    if (isTooltipShown()) return;

    var tooltip = document.getElementById('easter-tracker-tooltip');
    if (!tooltip) return;

    // Show after a short delay
    setTimeout(function() {
      tooltip.classList.add('is-visible');
    }, 1200);
  }

  function closeEasterTooltip() {
    var tooltip = document.getElementById('easter-tracker-tooltip');
    if (tooltip) {
      tooltip.classList.remove('is-visible');
    }
    markTooltipShown();
  }

  /* --- COPY CODE --- */
  function copyDiscountCode() {
    var codeEl = document.querySelector('.easter-tracker__code');
    if (!codeEl) return;

    var code = codeEl.textContent.trim();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(function() {
        showCopyFeedback();
      });
    } else {
      // Fallback
      var textarea = document.createElement('textarea');
      textarea.value = code;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showCopyFeedback();
    }
  }

  function showCopyFeedback() {
    var msg = document.querySelector('.easter-tracker__copy-msg');
    if (msg) {
      msg.classList.add('is-visible');
      setTimeout(function() {
        msg.classList.remove('is-visible');
      }, 2000);
    }
  }

  /* --- INIT --- */
  function init() {
    var found = getFoundEggs();

    // Mark already-found eggs
    var allEggs = document.querySelectorAll('.easter-egg');
    allEggs.forEach(function(egg) {
      var eggId = egg.dataset.eggId;
      if (found.includes(eggId)) {
        egg.classList.add('easter-egg--already-found');
      }
    });

    // Egg click handlers
    allEggs.forEach(function(egg) {
      egg.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        onEggClick(egg);
      });
    });

    // Tracker toggle
    var toggleBtn = document.querySelector('.easter-tracker__toggle');
    var panel = document.querySelector('.easter-tracker__panel');
    if (toggleBtn && panel) {
      toggleBtn.addEventListener('click', function() {
        panel.classList.toggle('is-open');
      });

      // Close panel on outside click
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.easter-tracker')) {
          panel.classList.remove('is-open');
        }
      });
    }

    // Tooltip close
    var tooltipClose = document.querySelector('.easter-tracker__tooltip-close');
    if (tooltipClose) {
      tooltipClose.addEventListener('click', function(e) {
        e.stopPropagation();
        closeEasterTooltip();
      });
    }

    // Copy code
    var codeEl = document.querySelector('.easter-tracker__code');
    if (codeEl) {
      codeEl.addEventListener('click', copyDiscountCode);
    }

    // Update tracker state
    updateTracker(found);

    // Show tooltip
    showEasterTooltip();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
